import Vue from 'vue'
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import App from './App.vue'
import VueFormulate from '@braid/vue-formulate'
import DatePicker from './components/inputs/DatePicker'
import MyFormulateAutocomplete from './components/inputs/MyFormulateAutocomplete'
import VueSimpleAlert from "vue-simple-alert";
Vue.use(VueSimpleAlert)

Vue.component('DatePicker', DatePicker)
Vue.component('MyFormulateAutocomplete', MyFormulateAutocomplete)

Vue.use(VueFormulate, {
	library: {
		datepicker: {
			classification: 'text',
			component: 'DatePicker'
		},
		autocomplete: {
			classification: 'text',
			component: 'MyFormulateAutocomplete'
		}
	}
})

import VueFormWizard from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
Vue.use(VueFormWizard)

import {
	Datetime
} from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";

import {
	Settings
} from "luxon";

Settings.defaultLocale = "fr";
Vue.use(Datetime);
Vue.component("datetime", Datetime);

import 'animate.css';

Vue.config.productionTip = false

const router = new VueRouter();

new Vue({
	router,
	render: h => h(App),
}).$mount('#app')